/** @flow */
export default {
  DATE: 'MM/dd/yyyy',
  TIME: 'HH:mm a',
  DATE_TIME: 'MM/dd/yyyy HH:mm a',
};
